const awsmobile = {
  aws_project_region: "us-east-1",
  aws_appsync_region: "us-east-1",
  aws_appsync_graphqlEndpoint:
    "https://ilsmwsj3qrddvd4r3426lxbpcu.appsync-api.us-east-1.amazonaws.com/graphql",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_appsync_region: "us-east-1",
  aws_appsync_apiKey: "da2-pnm7h266p5gkdbmzvhvonaqwge",
  aws_cognito_identity_pool_id:
    "us-east-1:85763b6a-1111-45e9-b0d1-c1893fa072c5",
  aws_user_pools_id: "us-east-1_P0g2Qcu4N",
  aws_cognito_region: "us-east-1",
  aws_user_pools_web_client_id: "7ttapffnm3l4i4ro1jnv06ta2v",
  aws_cloud_logic_custom: [
    {
      name: "AdminQueries",
      endpoint: "https://xscyi9d7se.execute-api.us-east-1.amazonaws.com/admin",
      region: "us-east-1"
    }
  ],
  oauth: {},
  aws_user_files_s3_bucket: "pnp-merchant-storage-qa",
  aws_user_files_s3_bucket_region: "us-east-1"
};

export default awsmobile;
